// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33lM9","icon":"styles_icon__it-2Z"};